// @ts-check
import { checkEnrichedName } from '../utils/string';
import { formatOddDisplay } from '@bto-services/utils';
/**
 * Model for Match Outcomes
 */
export default class TopEventsMatchesOutcomeModel {
  /**
   * @param {import('./interface').ApiTopEventOutcome} data - raw api data
   * @param {string} homeTeam - raw api home team
   * @param {string} guestTeam - raw api away team
   */
  constructor(data, homeTeam = "", guestTeam = "") {
    /**
     * Outcome ID
     * @type {number}
     */
    this.id = data.id;
    /**
     * Outcome Name
     * @type {string}
     */
    this.name = data.n && data.sbv && !data.eon ? `${data.n} (${data.sbv})` : data.n;
    /**
     * Outcome value
     * @type {string}
     */
    this.outcome = formatOddDisplay(data.o);
    /**
     * Original decimal value of outcome
     */
    this.originalOdd = data.o;
    /**
     * Suspended outcome
     * @type {boolean}
     */
    this.suspended = data.su;
    // /**
    //  * Identifier used for live matches
    //  * @type {string}
    //  */
    // this.identifier =
    //   typeof data.i !== 'undefined' && data.i !== null ? data.i : '';
    // /**
    //  * Specifier used for live matches
    //  * @type {string}
    //  */
    // this.specifier =
    //   typeof data.sp !== 'undefined' && data.sp !== null ? data.sp : '';
    /**
     * Column number (horizontal position)
     * @type {number}
     */
    this.column = data.col;
    /**
     * Special bet value
     * @type {string}
     */
    this.sbv = data.sbv;
    /**
     * Enriched Outcome Name
     * @type {string}
     */
    this.enrichedOutcomeName = checkEnrichedName(data.eon, homeTeam, guestTeam, data.sbv);
  }
}